import React, { useState, useEffect } from "react";
import { Select, Form, Input, Checkbox } from "antd";
import { connect } from "react-redux";

import QADynamicTable from "../../../../components/qa_custom/DynamicTable";
import { selectDataFromExecQuery } from "../../actions/funcional.group";
import { getColumnSearchProps } from "../search.into.table.columns";

const { Option } = Select;
const EXEC_QUERY_NAME = {
    parametros_comp_grupos_func: "parametros_comp_grupos_func",
    tipos_param_comportam: "tipos_param_comportam",
    categories: "qm_tipo_comportamento",
};

const Behavior = ({
    form,
    selectDataFromExecQuery, //from redux action
    soma_ponderacao_paramcomp,
    selectedGrupoExist,
    idGrupoExist,
    set_parametro_comportamental,
    parametro_comportamental,
    setBehavoirPonderationCalculeValue,
}) => {
    const [dataSource, setDataSource] = useState([]);
    const [behaviorTypes, setBehaviorTypes] = useState([]);
    const [categories, setCategories] = useState([]);

    const [sumPonderation, setSumPonderation] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (parametro_comportamental.length) {
            setDataSource(parametro_comportamental);
            setSumPonderation(!sumPonderation);
        }
    }, []);

    useEffect(() => {
        selectDataFromExecQuery({
            query: EXEC_QUERY_NAME.categories,
        }).then((response) => {
            if (response.result) {
                if (Array.isArray(response.result)) {
                    setCategories(response.result);
                }
            }
        });
    }, []);

    /**
     * do ponderation calcule
     */
    useEffect(() => {
        const sum = dataSource
            .filter((item) => item["ativo"] === "t")
            .map((item) => Number(item.ponderacao))
            .reduce((a, b) => a + b, 0);
        setBehavoirPonderationCalculeValue(sum);
    }, [sumPonderation]);

    /**
     * fetch "tipos parametros comportamentais"
     */
    useEffect(() => {
        (async () => {
            setLoading(true);
            const response = await selectDataFromExecQuery({
                query: EXEC_QUERY_NAME.tipos_param_comportam,
            });
            if (response.result) {
                if (Array.isArray(response.result)) {
                    setBehaviorTypes(response.result);
                }
            }
            setLoading(false);
        })();
    }, []);

    /**
     * add row to table
     */
    const addRowToTable = () => {
        let size = dataSource.length > 0 ? Math.max(...dataSource.map((item) => Number(item.__key__))) + 1 : 0;
        setDataSource([{ __key__: size }, ...dataSource]);
    };

    /**
     * remove row from table
     */
    const removeRowFromTable = (selectedRowKeys) => {
        const newDataSource = [];
        dataSource.forEach((item) => {
            if (!selectedRowKeys.includes(item.__key__)) newDataSource.push(item);
        });
        setDataSource(newDataSource);
        setSumPonderation(!sumPonderation);
    };

    /**
     * handle change when user enter degit
     */
    const onChange = async (dataIndex, value, record) => {
        const newState = [...dataSource];

        record[dataIndex] = value;
        const index = newState.findIndex((item) => item.__key__ === record.__key__);
        newState.splice(index, 1, record);
        // newState[index] = record;

        await setDataSource([...newState]);

        set_parametro_comportamental([...newState]);

        if (dataIndex === "ponderacao" || dataIndex === "ativo") {
            setSumPonderation(!sumPonderation);
        }
    };

    /**
     * columns to table
     */
    const columns = [
        {
            title: "Tipos de comportamento",
            dataIndex: "tipo_comportamento",
            width: "30%",
            ...getColumnSearchProps("tipo_comportamento"),
            onFilter: (value, record) => {
                const filteredValue = categories
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.tipo_habilidade);
                return filteredValue.includes(record["tipo_comportamento"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "300px", margin: "0 auto", padding: "0" }}
                        placeholder="Selecione uma opção"
                        optionFilterProp="children"
                        value={categories
                            .map((element) => element.id_tipo_comportamento)
                            .find((item) => item === defaultValue)}
                        onChange={(value) => {
                            onChange("tipo_comportamento", value, record);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {categories.map((item) => (
                            <Option key={item.id_tipo_comportamento} value={item.id_tipo_comportamento}>
                                {item.designacao}
                            </Option>
                        ))}
                    </Select>
                );
            },
        },
        {
            title: "Designação",
            dataIndex: "tipo_parametros_comportam",
            width: "30%",
            ...getColumnSearchProps("tipo_parametros_comportam"),
            onFilter: (value, record) => {
                const filteredValue = behaviorTypes
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.tipo_parametros_comportam);
                return filteredValue.includes(record["tipo_parametros_comportam"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                const list = record.tipo_comportamento
                    ? behaviorTypes.filter((item) => item.tipo_comportamento === record.tipo_comportamento)
                    : behaviorTypes;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "600px", margin: "0 auto", padding: "0" }}
                        placeholder="Seleciona uma opção"
                        optionFilterProp="children"
                        value={list
                            .map((element) => element.tipo_parametros_comportam)
                            .find((item) => item === defaultValue)}
                        onChange={(value) => {
                            onChange("tipo_parametros_comportam", value, record);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {list.map((item) => (
                            <Option key={item.tipo_parametros_comportam} value={item.tipo_parametros_comportam}>
                                {item.designacao}
                            </Option>
                        ))}
                    </Select>
                );
            },
        },
        {
            title: "Ponderação",
            dataIndex: "ponderacao",
            width: "20%",
            ...getColumnSearchProps("ponderacao"),
            render: (text, record) => (
                <Form.Item style={{ width: "100%", margin: "0 auto", padding: "0" }}>
                    <Input
                        onChange={(e) => onChange("ponderacao", e.target.value, record)}
                        type="number"
                        defaultValue={typeof text !== "object" ? text : undefined}
                        style={{ width: "100%" }}
                        placeholder="Introduza a ponderação"
                    />
                </Form.Item>
            ),
        },
        {
            title: "Ativo?",
            dataIndex: "ativo",
            width: "10%",
            align: "center",
            ...getColumnSearchProps("ativo"),
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => onChange("ativo", e.target.checked === true ? "t" : "f", record)}
                    defaultChecked={text === "t" || text === true}
                />
            ),
        },
    ];

    return (
        <>
            <QADynamicTable
                data={dataSource}
                columns={columns}
                addRowToTable={addRowToTable}
                onRemoveItem={removeRowFromTable}
                loadingData={loading}
            />
        </>
    );
};

const mapDispatchToProps = {
    selectDataFromExecQuery,
};

export default connect(null, mapDispatchToProps)(Behavior);
